module.exports = __webpack_public_path__ + "site-build/img/promotion_banner.28a33c14.png";